export default __webpack_public_path__ + "images/b6f1337bf2370a4a162a55250b2976f9.svg";